import * as React from "react";

interface ButtonProps {
    className: string;
    normalImgSrc: string;
    onClicked: () => void;
}

export class Button extends React.Component<ButtonProps, {}> {
    render(): JSX.Element {
        return <img className={this.props.className + " clickable"}
                    src={this.props.normalImgSrc}
                    onClick={this.props.onClicked}/>;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/button.tsx